import { useMemo } from "react"

// https://stackoverflow.com/a/12646864/505650
function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

const useShuffledContacts = (contacts = []) => {
  return useMemo(() => (contacts ? shuffle(contacts) : []), [contacts])
}

export default useShuffledContacts
